import { createPopper, Instance } from '@popperjs/core';

type Trigger = 'hover' | 'click';

type Options = {
    trigger?: Trigger,
    hideDelay?: number
}

let visibleTooltip: Tooltip = null;
let hideTimer: number = null;

class Tooltip {
  el:       HTMLElement;
  tt:       HTMLElement;
  trigger:  Trigger;
  pop:      Instance;
  hideDelay: number;

  constructor(el: Element, tt: Element, options: Options = {}) {
    this.el      = el as HTMLElement;
    this.tt      = tt as HTMLElement;

    this.trigger   = options.trigger || 'hover';
    this.hideDelay = options.hideDelay || 200;

    this.init();
  }

  init() {
    this.pop = createPopper(this.el, this.tt, {
        placement: "auto",
        modifiers: [
            { name: 'eventListeners', enabled: false },
        ]
    });

    this.el.addEventListener("touchstart", (e) => {
        this.show();

        const onClickOutside = (e: Event) => {
            const el = (e.target as Element);

            if (visibleTooltip === this) {
                if (this.el.contains(el) || this.tt.contains(el)) {
                    // Clicked within the el/tt again, do nothing
                } else {
                    this.hide();

                    window.removeEventListener('touchend', onClickOutside);
                }
            }
        };

        window.addEventListener('touchend', onClickOutside);
    });

    this.el.addEventListener("mouseenter", (e) => {
        this.show();
    });

    this.el.addEventListener("mouseleave", (e) => {
        this.delayedHide();
    });

    this.tt.addEventListener("mouseenter", (e) => {
        this.keepVisible();
    });

    this.tt.addEventListener("mouseleave", (e) => {
        this.delayedHide();
    });
  }

  show() {

    if (visibleTooltip) {
        if (hideTimer) {
            clearTimeout(hideTimer);
        }

        if (visibleTooltip !== this) {
            visibleTooltip.hide()
        }
    }


    this.tt.setAttribute('data-show', '');

    this.pop.setOptions((options) => ({
        ...options,
        modifiers: [
            ...options.modifiers,
            { name: 'eventListeners', enabled: true },
        ],
    }));

    this.pop.update();

    visibleTooltip = this;

  }

  keepVisible() {

    if (visibleTooltip === this) {
        if (hideTimer) {
            clearTimeout(hideTimer);
        }
    }

  }

  delayedHide() {
    hideTimer = window.setTimeout(() => {
        this.hide();
    }, this.hideDelay);
  }

  hide() {
    this.tt.removeAttribute('data-show');

    this.pop.setOptions((options) => ({
        ...options,
        modifiers: [
            ...options.modifiers,
            { name: 'eventListeners', enabled: false },
        ],
    }));

    visibleTooltip = null;

  }
}

export { Tooltip };
